import { createVNode as _createVNode, isVNode as _isVNode, mergeProps as _mergeProps } from "vue";
import { defineComponent } from 'vue';
import { TreeSelect as AntTreeSelect } from 'ant-design-vue';
import { treeSelectProps as antTreeSelectProps } from 'ant-design-vue/es/tree-select';
import Wrapper from '../wrapper';
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
const elfTreeSelectProps = {};
const treeSelectProps = {
  ...antTreeSelectProps(),
  ...elfTreeSelectProps
};
const TreeSelect = defineComponent({
  name: 'ElfTreeSelect',
  props: treeSelectProps,
  setup(props, {
    attrs,
    slots
  }) {
    return () => _createVNode(Wrapper, null, {
      default: () => [_createVNode(AntTreeSelect, _mergeProps(props, attrs), _isSlot(slots) ? slots : {
        default: () => [slots]
      })]
    });
  }
});
export default TreeSelect;